import ScannersAnnouncements from './Announcements.container';

// announcements list
import './OmniBanner';

export default ScannersAnnouncements;
